/** Voucher sales / distribution channels */
export enum DistributionChannel {
    StoryHuntHome = "StoryHuntHome",        // Voucher is purchased through home cart page
    StoryHuntApp = "StoryHuntApp",          // Voucher is purchased through home cart but referred to from app
    StoryHuntCreator = "StoryHuntCreator",  // Voucher is created though Creator by a Creator (admin)
    StoryHuntAdmin = "StoryHuntAdmin",      // Voucher is created though Creator by us (super admin)
    GetYourGuide = "GetYourGuide",          // Voucher is purchased through GetYourGuide
    TrueStory = "TrueStory",                // Voucher is purchased through Truestory
    GoBoat = "GoBoat",                      // Voucher is purchased though GoBoat
    GoDream = "GoDream",                    // Voucher is purchased though GoDream
    Vos = "Vos",                            // Voucher is purchased though Vision of Scandinavia
    Campaign = "Campaign",                  // Voucher is purchased as a result of a campaign (i.g. on SOME)
    CypressTest = "CypressTest",            // Voucher is created as a part of a cypress test
    Viator = "Viator",                      // Voucher is purchased though Viator
    TaelSkridt = "TaelSkridt",              // Voucher is given away though Tæl Skridt campaign
    DealDK = "DealDK"                       // Voucher is purchased though deal.dk
}

export type DistributionChannelString = DistributionChannel | string;
